// extracted by mini-css-extract-plugin
export var text = "_8y-0";